import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractValueFormulaToken from "./AbstractValueFormulaToken.js";
import AccountFormulaNode from "../formula/AccountFormulaNode.js";
import AccountGroupSpecification from "../../accountSpecification/AccountGroupSpecification.js";

/**
 * Value token representing an account group.
 *
 * @param {string} spec.groupId - Unique identifier of the account group.
 * @param {string} spec.groupLabel - User-visible name of the account group.
 */
export default class AccountGroupFormulaToken extends AbstractValueFormulaToken {
	constructor({ groupId, groupLabel } = {}) {
		super(...arguments);
		this._groupId = groupId;
		this._groupLabel = groupLabel;
	}

	getGroupId() {
		return this._groupId;
	}

	getGroupLabel() {
		return this._groupLabel;
	}

	setGroup(group) {
		this._groupId = group.getId();
		this._groupLabel = group.getName();
	}

	accept(visitor) {
		return visitor.visitAccountGroupFormulaToken(this);
	}

	_asBaseFormulaNode() {
		return new AccountFormulaNode({
			accountSpecification: new AccountGroupSpecification({
				groupId: this._groupId,
				groupLabel: this._groupLabel,
			}),
		});
	}

	static getLabel() {
		return _("Chart of Accounts Group");
	}

	static getType() {
		return "account-group";
	}

	static isVisible(context) {
		return context.isAccountGroupsUsageInKpiEditorEnabled;
	}
}
